const FORMATTER = Intl.NumberFormat('en', { notation: 'compact' });

export default function formatNumber(number) {
  return FORMATTER.format(number);
}
